import {channelDistributionTemplateFormToQuery as formToQuery } from './channelDistributionTemplateFormToQuery';
import {channelDistributionTemplateQueryToForm as queryToForm } from './channelDistributionTemplateQueryToForm';

export default { formToQuery, queryToForm };
